<template>
  <div class="verify-history">
    <template v-if="isList">
      <div class="history-list" key="history-list" v-ps v-if="histories.length">
        <div
          v-for="(verify, index) in histories"
          :key="index"
          class="verify"
          @click="getVerifyDetail(verify)"
        >
          <div class="title">
            <div class="name" v-tip>{{ verify.name }}</div>
          </div>
          <div class="content">
            <div class="content-item data">
              <div class="label">开始时间</div>
              <div class="value" v-tip>{{ verify.startTime }}</div>
            </div>
            <div class="content-item">
              <div class="label">结束时间</div>
              <div class="value" v-tip>{{ verify.endTime }}</div>
            </div>
          </div>
          <div class="result-info">
            <div class="creator">
              <staff-popover :staffId="verify.creator.id">
                <template v-slot:reference>
                  <staff-avatar class="avatar" :size="30" :user="verify.creator"></staff-avatar>
                </template>
              </staff-popover>
              <div class="des" v-tip>
                由{{ verify.creator.name ? verify.creator.name.toUpperCase() : "无" }}提交
              </div>
            </div>
            <div class="result" :class="verify.result">{{ verifyResultMap[verify.result] }}</div>
          </div>
        </div>
      </div>
      <div v-else class="empty"><span>暂无审批历史</span></div>
    </template>
    <div v-else class="history-detail">
      <div class="title">
        <div class="name">
          <i class="el-icon-arrow-left pointer" style="font-weight: 600" @click="goBack"></i>
          <span>{{ verify.name }}</span>
        </div>
        <div class="result" :class="verify.result">
          {{ verifyResultMap[verify.result] }}
        </div>
      </div>
      <verify-process :process-info="verify.detailInfo" from="history"></verify-process>
    </div>
  </div>
</template>

<script>
import { verifyResultMap } from "@/components/Sheet/DetailDialog/static"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import { getVerifyProcessesBySheetDataId } from "@/api/project/task"
import { getUser } from "@/utils/user"
import processMixin from "@/components/Sheet/DetailDialog/ProcessMixin"
import VerifyProcess from "@/components/Sheet/DetailDialog/VerifyProcess"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "VerifyHistory",
  components: { StaffAvatar, VerifyProcess, StaffPopover },
  props: { dataId: String, dataTitle: String },
  data() {
    return {
      verifyResultMap,
      isList: true,
      histories: [],
      verify: {}
    }
  },
  mixins: [processMixin],
  watch: {
    dataId: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  methods: {
    init() {
      getVerifyProcessesBySheetDataId(this.dataId, false).then(res => {
        let verifyHistoryList = this._.reverse(res)
        this.getHistories(verifyHistoryList)
        this.isList = true
      })
    },
    getHistories(historyList) {
      let result = []
      historyList.forEach(history => {
        let historyInfo = {}
        let startVerify = history[0]
        let finishVerify = history[history.length - 1]
        historyInfo.name = startVerify.workflow?.name
        historyInfo.startTime = startVerify.createAt
        historyInfo.creator = getUser(startVerify.userId)
        historyInfo.endTime = finishVerify.finishAt
        historyInfo.result = finishVerify.pass === true ? "pass" : "reject"
        if (finishVerify.status == "RECALLED") historyInfo.result = "recalled"
        historyInfo.detailInfo = this.getDetailInfo(history)
        result.push(historyInfo)
      })
      this.histories = result
    },
    getUserName(userId) {
      return getUser(userId)?.name || "未知用户"
    },
    getVerifyDetail(verify) {
      this.isList = false
      this.verify = verify
    },
    goBack() {
      this.isList = true
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-history {
  padding-bottom: 60px;
  padding-left: 10px;
  height: 100%;
  .empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .history-list {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    height: 100%;
    .verify {
      background-color: #fff;
      border-radius: 4px;
      height: 100px;
      margin: 0 10px 10px 0;
      padding: 12px 14px;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;
        .name {
          flex: 1;
          font-size: 15px;
          color: #313132;
          font-weight: 500;
        }
        .time {
          font-size: 12px;
          color: #878a90;
        }
      }
      .content {
        margin-bottom: 6px;
        .data {
          margin-bottom: 2px;
        }
        .content-item {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #878a90;
          .label {
            width: 60px;
          }
          .value {
            flex: 1;
          }
        }
      }
      .result-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .creator {
          display: flex;
          align-items: center;
          flex: 1;
          overflow: hidden;
          .avatar {
            margin-right: 6px;
          }
          .des {
            font-size: 14px;
            color: #313132;
            flex: 1;
          }
        }
      }
    }
  }
  .history-detail {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    height: 100%;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      padding-right: 13px;
      .name {
        font-size: 14px;
        color: #878a90;
        font-weight: 500;
      }
    }
  }
  .result {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
  .pass {
    border: 1px solid #40d492;
    color: #40d492;
  }
  .reject {
    border: 1px solid #fd6565;
    color: #fd6565;
  }
  .recalled {
    border: 1px solid #a2a2a2;
    color: #a2a2a2;
  }
  .cancel {
    border: 1px solid #c0c4cc;
    color: #878a90;
  }
}
</style>
